document.addEventListener('DOMContentLoaded', function () {
  let checkbox = document.querySelector('#togglePersonalization');
  let dropdown = document.querySelector('.note_input-field');

  if (!checkbox || !dropdown) return;

  checkbox.addEventListener('change', radioCheck);
 async function radioCheck(){
     const isChecked = checkbox.checked;
    const radioSelector = isChecked
      ? 'input[type="radio"][value="Yes"]'
      : 'input[type="radio"][value="No"]';

    const radio = document.querySelector(radioSelector);

    if (isChecked) {
      console.log('checked');
      dropdown.classList.remove('hidden');
    } else {
      console.log('unchecked');
      dropdown.classList.add('hidden');
    }

    if (radio) {
      radio.checked = true; 
      radio.dispatchEvent(new Event('change', { bubbles: true })); 
      radio.click();
      if(radio.value === "No"){
        let monogramInputs = document.querySelectorAll('.monogram-custom-input input');
        monogramInputs.forEach((input)=>{
              input.value='';
          })
      }
     
    } else {
      console.warn(`Radio button not found for selector: ${radioSelector}`);
    }
   
 }
  radioCheck();
})